import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Button } from '../../../../components/Button';
import { StyledDropdownOption } from '../../../../components/Dropdown/styles';

export const StyledEmailPreviewFooter = styled.div`
  margin: 8px 0 0 0;
  display: inline-flex;
  align-items: center;
  width: 100%;
`;

export const StyledVariantsNavigationButton = styled.button`
  border: none;
  background: transparent;
  box-shadow: none;
  padding: 0;
  margin: 0;
  cursor: pointer;

  ${SWReactIcons} {
    width: 12px;
    height: 12px;

    svg path {
      fill: ${colorsPalettes.carbon[400]};
      fill-opacity: 1;
    }
  }

  &:disabled {
    cursor: not-allowed;

    ${SWReactIcons} svg path {
      fill: ${colorsPalettes.carbon[100]};
    }
  }
`;

export const StyledVariantsView = styled.span`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])};
  line-height: normal;
  letter-spacing: 0.12px;
`;

export const StyledCopyButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  column-gap: 3px;
  padding: 6px 12px;
  background-color: transparent;
  margin-left: auto;
  ${setFontVariant('button', colorsPalettes.blue[400])};
  font-size: 10.5px;
  line-height: 15px;

  &:disabled {
    background-color: transparent;
    color: ${colorsPalettes.carbon[100]};
    cursor: not-allowed;
  }
`;

export const StyledFeedbackButtons = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const StyledFooterButton = styled(Button)<{ flip?: boolean; isActive?: boolean }>`
  background-color: ${({ isActive }) => (isActive ? colorsPalettes.blue[200] : 'transparent')};
  padding: 4px;
  position: relative;

  ${SWReactIcons} {
    ${({ flip }) => flip && 'transform: rotateY(180deg);'}
    &[data-automation-icon-name="toggle-filters"] {
      padding-top: 1px;
    }
  }

  &:disabled {
    background-color: transparent;
  }
`;

export const StyledFooterButtonTooltip = styled.span`
  white-space: nowrap;
`;

export const StyledRegenerateDropdownOption = styled(StyledDropdownOption)`
  gap: 8px;
  padding: 10px 16px;
`;

export const StyledRegenerateContainer = styled.div`
  position: relative;
`;
